var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "#546F7A",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.678 1.393.464 9.646c-.346.404-.057.98.462.98H18.7c.52 0 .808-.634.462-.98l-7.271-8.253a2.726 2.726 0 0 0-4.213 0ZM17.835 12.185v8.08a.578.578 0 0 1-.577.576H2.31a.578.578 0 0 1-.577-.577v-8.079h16.1Z"
  })));
};

export default SvgHome;